export default __webpack_public_path__ + "static/media/yellow_medium.56b15e6d.png";